/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { connect } from 'react-redux'

import {
  getFile,
  saveFile,
  saveAllFiles,
} from 'app/state/modules/codeReview'
import FileElement from './FileElement'
import FolderElement from './FolderElement'

class FileTree extends React.Component {
  getFileTree(obj, level) {
    if (this.props.loadingFiles) {
      return (
        <div
          className="uk-flex uk-flex-center uk-flex-middle uk-flex-column"
        >
          <br />
          <br />
          <span data-uk-spinner="ratio: 0.75" />
          <span
            className="uk-text-small uk-margin-small-top"
          >
            Loading Files...
          </span>
        </div>
      )
    }
    const x = []
    if ('directories' in obj) {
      x.push(
        <ul
          className="uk-nav-sub file-manager uk-text-small"
          data-uk-nav="multiple: true"
          key={`directory-level-${level}`}
          style={{
            paddingLeft: level > 1 ? 5 : 0,
          }}
        >
          {(obj.directories || []).map((item, index) => {
            return (
              <FolderElement
                isActive={this.props.foldersActive[item.name] === level}
                isOpen={this.props.initialPath.slice(0, level).join('/') === item.path}
                key={`directory-${index}`}
                item={item}
                renderLevels={() => this.getFileTree(item, level + 1)}
              />
            )
          })}
          {(obj.files || []).map((item) => {
            const isFocus = this.props.tabs
              && this.props.tabs[this.props.indexEditing]
              && this.props.tabs[this.props.indexEditing].file === item.path
            return (
              <FileElement
                key={item.path}
                isFocus={isFocus}
                item={item}
                lockedFiles={this.props.lockedFiles}
                loadingVersion={this.props.loadingVersion}
                getFile={this.props.getFile}
              />
            )
          })}
        </ul>,
      )
    }
    return x
  }

  render() {
    return (
      <>
        <ul
          className="uk-nav-default uk-nav-parent-icon"
          data-uk-nav="multiple: true"
          id="filetree"
        >
          {this.getFileTree(this.props.filesystem, 1)}
        </ul>
        {this.props.hasSave && (
          <div className="uk-align-bottom">
            <button
              onClick={() => {
                this.props.saveAllFiles()
              }}
              type="button"
              style={{ marginBottom: 0 }}
              className="uk-button uk-button-small uk-button-primary  uk-margin-left"
            >
              Save All Changes
            </button>
          </div>
        )}
      </>
    )
  }
}

const mapStateToProps = ({ codeReview }) => ({
  defaultFile: codeReview.defaultFile,
  filesystem: codeReview.filesystem,
  indexEditing: codeReview.indexEditing,
  tabs: codeReview.tabs,
  sandboxAppUrl: codeReview.sandboxAppUrl,
  loadingVersion: codeReview.loadingVersion,
  loadingFiles: codeReview.loadingFiles,
  initialPath: codeReview.initialPath,
  foldersActive: (((codeReview.tabs || [])[codeReview.indexEditing] || {}).file || '').split('/').reduce((p, c, i) => {
    p[c] = i + 1
    return p
  }, {}),
})

export default connect(mapStateToProps, {
  getFile,
  saveFile,
  saveAllFiles,
})(FileTree)
